import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

export interface DividerProps {
  vertical?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const Divider = ({ vertical, className, style }: DividerProps) => (
  <hr
    style={style}
    className={cn(
      "flex-none border-0 bg-gray-200",
      vertical ? "min-h-full w-0.5" : "h-0.5 min-w-full",
      className,
    )}
  />
);
